import { render } from "./cratetypelist.vue?vue&type=template&id=52909324"
import script from "./cratetypelist.vue?vue&type=script&lang=js"
export * from "./cratetypelist.vue?vue&type=script&lang=js"

import "./cratetypelist.vue?vue&type=style&index=0&id=52909324&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__